import * as React from "react";
import { Dialog, DialogType, DialogFooter } from "@fluentui/react/lib/Dialog";
import { PrimaryButton, DefaultButton } from "@fluentui/react/lib/Button";
import { ActivityJson } from "../../../system/activity/ActivitySystem";

interface ActivityAlreadyExistsModalProps {
  activity: ActivityJson | null;
  isOpen: boolean;
  onClose: () => void;
  onJoin: (activity: ActivityJson) => void;
}

export const ActivityAlreadyExistsModal: React.FC<ActivityAlreadyExistsModalProps> = ({
  activity,
  isOpen,
  onClose,
  onJoin,
}) => {
  return (
    <Dialog
      hidden={!isOpen}
      onDismiss={onClose}
      dialogContentProps={{
        type: DialogType.normal,
        title: "Actividad ya registrada",
        closeButtonAriaLabel: "Cerrar",
        subText: activity
          ? `La actividad "${activity.act_nombre}" ya se encuentra registrada. ¿Deseas agregarte a esta actividad?`
          : "",
      }}
      modalProps={{
        isBlocking: true, // obliga al usuario a elegir
      }}
    >
      <DialogFooter>
        <PrimaryButton
          onClick={() => activity && onJoin(activity)}
          text="Sí, agregarme"
        />
        <DefaultButton onClick={onClose} text="Cancelar" />
      </DialogFooter>
    </Dialog>
  );
};
